module.exports = __webpack_public_path__ + "img/024-witch.570afeab.png";